import { alpha, Theme } from "@mui/material/styles";

export const getDashboardPanelSx = (theme: Theme, minHeight?: number) => ({
  minHeight,
  height: "100%",
  position: "relative" as const,
  overflow: "hidden" as const,
  borderRadius: "12px",
  border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.1)}`,
  background:
    theme.palette.mode === "dark"
      ? `linear-gradient(180deg, ${alpha("#152238", 0.94)} 0%, ${alpha("#0a1220", 0.98)} 100%)`
      : `linear-gradient(180deg, ${alpha("#ffffff", 0.98)} 0%, ${alpha("#eef5ff", 0.94)} 100%)`,
  boxShadow:
    theme.palette.mode === "dark"
      ? `0 18px 40px ${alpha("#020611", 0.45)}`
      : `0 18px 40px ${alpha("#91a7c4", 0.18)}`,
  backdropFilter: "blur(16px)",
  "&::before": {
    content: '""',
    position: "absolute" as const,
    inset: 0,
    pointerEvents: "none" as const,
    background:
      theme.palette.mode === "dark"
        ? `radial-gradient(circle at top right, ${alpha("#6ee7ff", 0.14)}, transparent 32%), radial-gradient(circle at bottom left, ${alpha("#7c3aed", 0.1)}, transparent 28%)`
        : `radial-gradient(circle at top right, ${alpha("#60a5fa", 0.16)}, transparent 34%), radial-gradient(circle at bottom left, ${alpha("#38bdf8", 0.12)}, transparent 28%)`,
  },
});

export const dashboardMutedTextSx = (theme: Theme) => ({
  color: alpha(theme.palette.text.primary, 0.68),
});
